import { useDateFormat } from '@vivaldis/common'
import { useMemo } from 'react'
import { PayslipsTabPayslipsQuery_payslips as Payslip } from '../../../graphql/__generated__/PayslipsTabPayslipsQuery'

interface Props {
  payslip: Payslip
}

export const WageDate = ({ payslip }: Props) => {
  const formatDate = useDateFormat('dd/MM/yyyy')

  const text = useMemo(() => {
    if (payslip.wageDate) {
      return formatDate(new Date(payslip.wageDate))
    }
    return null
  }, [formatDate, payslip.wageDate])

  return <>{text}</>
}
